<template>
  <div class="section" style="flex-direction: row;padding: 20px 20px 10px 20px">
    <el-form :disabled="readonly" :inline="true" label-width="90px" label-position="left">
      <el-form-item :label="$t('Partners.agentLevel')" style="margin-right: 40px">
        <el-select v-model="form.grade" no="grade" style="width: 350px">
          <el-option :label="$t('Partners.masterAgent')" :value="0" />
          <el-option :label="$t('Partners.secondaryAgent')" :value="1" />
        </el-select>
      </el-form-item>
      <br>
      <el-form-item :label="$t('Partners.networkManager')">
        <cargo-user-select
          no="networkManager"
          :method-params="{category:'role',shape:'sales'}"
          :callback-params="{key:'owner'}"
          :default-value="form.owner||''"
          style="width: 350px;"
          @change="params=>form.owner=params.value"
        />
      </el-form-item>
      <br>
      <el-form-item :label="$t('Partners.billingAddress')">
        <el-input v-model="form.billAddress" no="billAddress" type="textarea" :rows="10" style="width: 350px;" />
      </el-form-item>
      <br>
      <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
        <el-input v-model="form.remark" no="remark" type="textarea" :rows="10" style="width: 350px;" />
      </el-form-item>
    </el-form>
    <div v-if="networkList.length>0" style="width: 350px;height: 238px">
      <span>{{ $t('Partners.network') }}</span>
      <cargo-ag-grid
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="networkList"
        style="height: 100%"
        @gridReady="params=>{gridApi=params.api}"
      />
    </div>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getNetworkList } from '@/api/basicData/network'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { cache } from '@/utils/cacheManager'
import { TabError } from '@/utils/class/TabError'

export default {
  name: 'DesignationAgentForm',
  components: { cargoAdvanceSelect, cargoUserSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      networkList: [],
      selectTypeNames: TYPE_NAMES,
      form: {
        uuid: '',
        grade: 0,
        network: '',
        networkArr: [],
        owner: '',
        billAddress: '',
        companyUuid: ''
      },
      checkPrintNetCode: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('Partners.network'),
          field: 'name',
          width: 137
        }, {
          headerName: this.$t('Partners.code'),
          field: 'code',
          width: 137
        }
      ],
      gridApi: null
    }
  },
  computed: {
    readonly() {
      return !this.action || this.action === 'look'
    }
  },
  created() {
    this.checkPrintNetCode = Number(cache.config.get('checkPrintNetCode')) === 1
    getNetworkList({ pageNum: 1, pageSize: 1000000 }).then(res => {
      this.networkList = res.data.list
      if (this.networkList.length > 0) {
        setTimeout(() => {
          this.updateNetworkSelected()
        }, 100)
      }
    })
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.form = row.overseaAgentDetail
        this.form.owner = this.form.owner || 0
        if (this.networkList.length > 0) {
          this.updateNetworkSelected()
        }
        if (!this.form.companyUuid) {
          this.form.companyUuid = row.uuid
        }
      }
    },
    updateNetworkSelected() {
      const networkArr = this.form.network ? this.form.network.split(',') : []
      const nodes = this.gridApi.rowModel.rowsToDisplay
      for (const node of nodes) {
        if (networkArr.includes(node.data.code)) {
          node.setSelected(true)
        } else {
          node.setSelected(false)
        }
      }
    },
    getSubmitData() {
      const form = this.form
      this.checkModel()
      if (this.networkList.length > 0) {
        const rows = this.gridApi.getSelectedRows()
        form.network = Array.from(rows, p => p.code).join(',')
      }
      return {
        overseaAgentDetail: form
      }
    },
    checkModel() {
      if (!this.checkPrintNetCode) {
        return true
      }
      if (!this.form || !this.form.billAddress) {
        throw new TabError(this.$t('Partners.billAddressCannotEmpty'), 'designationAgentForm')
      }
      if (!this.form.owner || this.form.owner === 0) {
        throw new TabError(this.$t('Partners.nmsCannotEmpty'), 'designationAgentForm')
      }
      return true
    }
  }
}
</script>

<style>
</style>
